import { Group } from "~/components/glossaryBrands/types";
import GlossaryContainer from "~/components/glossaryBrands/GlossaryContainer";
import GlossaryMenu from "~/components/glossaryBrands/GlossaryMenu";
import Breadcrumb from "~/components/ui/Breadcrumb";

import { useState } from "react";
import { type SectionProps as SectionProps } from "~/types/deco";
export interface Props {
    /**
     * @title Itens
     * @description Lista de itens do glossário de marcas
     */
    groups: Group[];
}
const breadcrumb = [{
        '@type': 'ListItem' as const,
        item: '/marcas-para-revender-sex-shop',
        name: 'Glossário de marcas',
        position: 0,
    }];
export default function GlossaryBrands({ groups, letters, categories }: SectionProps<typeof loader>) {
    const [selectedCategory, setSelectedCategory] = useState('');
    const [valueSearch, setValueSearch] = useState('');
    const [activeLetter, setActiveLetter] = useState('');
    return (<div className='w-full max-w-[1800px] mx-auto'>
      <div className='px-4 my-5 flex items-center gap-2'>
        <Breadcrumb itemListElement={breadcrumb}/>
      </div>

      <GlossaryMenu activeLetter={activeLetter} categories={categories} letters={letters} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} setValueSearch={setValueSearch} valueSearch={valueSearch}/>

      <GlossaryContainer groups={groups} selectedCategory={selectedCategory} setActiveLetter={setActiveLetter} valueSearch={valueSearch}/>
    </div>);
}
export const loader = (props: Props, request: Request) => {
    if (!props?.groups?.length) {
        // Misconfigured section — render empty state instead of crashing.
        return { ...props, listBrands: [], groups: [], letters: [], categories: [] };
    }
    const listBrands = props.groups
        .filter(({ items }) => items.length)
        .map(({ items, ...group }) => ({
        ...group,
        items: items.map((item) => ({
            ...item,
            url: item.url ?? new URL(item.label.toUpperCase(), request.url).pathname,
        })),
    }));
    const groups = listBrands.map((group) => group.items).flat();
    const letters = props.groups.map((group) => group.label);
    const categoriesFormatted = groups.reduce((acc, group) => {
        const categoriesString = group.category;
        if (!categoriesString)
            return acc;
        const categories = categoriesString.split(',');
        const categoriesArr = categories.map((category) => category.trim().toLowerCase());
        return acc = [...acc, ...categoriesArr];
    }, ['Todas as categorias'] as string[]);
    const categories = [...new Set(categoriesFormatted)].sort();
    return { ...props, groups, letters, categories };
};
